<template>
  <div>
      <div class="content-section introduction" id="component">
        <div>
          <span class="feature-title">Password</span>
          <span>Password displays strength indicator for password fields.</span>
        </div>
      </div>
      <div id="wrapper">

        <h3 class="first">Basic</h3>
        <vf-password />

      </div>
  </div>
</template>

<script>
  export default {
    name: 'passworddemo',
    data () {
      return {};
    }
  };
</script>



// WEBPACK FOOTER //
// showcase/src/components/password/passworddemo.vue